export default "__VITE_ASSET__78cd8fa3__"